var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ctm-tools" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ctm-tools__body" },
      [
        _c(
          "el-tabs",
          {
            staticClass: "ctm-tools__tabs",
            model: {
              value: _vm.activeTab,
              callback: function($$v) {
                _vm.activeTab = $$v
              },
              expression: "activeTab"
            }
          },
          [
            _c(
              "el-tab-pane",
              { attrs: { name: "export" } },
              [
                _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                  _c("i", { staticClass: "el-icon-download" }),
                  _vm._v(" Export Forms")
                ]),
                _vm._v(" "),
                _c("exportforms")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-tab-pane",
              { attrs: { name: "import" } },
              [
                _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                  _c("i", { staticClass: "el-icon-upload2" }),
                  _vm._v(" Import Forms")
                ]),
                _vm._v(" "),
                _c("importforms")
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ctm-tools__header" }, [
      _c("h1", { staticClass: "ctm-tools__title" }, [_vm._v("Tools")]),
      _vm._v(" "),
      _c("p", { staticClass: "ctm-tools__subtitle" }, [
        _vm._v("Export and import your Contactum forms.")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }